import { Typography, Stack, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';
import { useAnalytics, TrackTypeEnum } from '@/hooks/useAnalytics';
import type { SxProps, Theme } from '@mui/material/styles';

const YOUTUBE_URL = 'https://youtube.com/playlist?list=PLu0WpBQHUSql4tPg9BHzvp-7ajhDMRFBE&si=KgwfIlNDajr3F-w2';

const EVENT_URL = 'https://fig-events.figma.com/get-started-figma-weave/';
const EVENT_DEADLINE = new Date('2026-04-16T11:00:00-07:00');

const PROMO_TERMS_URL = 'https://www.figma.com/figma-weave-promo-terms/';

const INLINE_LINK_SX: SxProps<Theme> = {
  color: color.White100,
  textDecoration: 'underline',
};

const SOURCE = 'figma_promo_welcome';

export function FigmaPromoFooter() {
  const { t } = useTranslation();
  const { track } = useAnalytics();
  const showEvent = Date.now() < EVENT_DEADLINE.getTime();

  const trackLinkClick = (link: 'youtube' | 'live_event' | 'promo_terms') => {
    track('figma_promo_link_clicked', { source: SOURCE, link }, TrackTypeEnum.BI);
  };

  return (
    <Stack alignItems="center" sx={{ gap: 2, textAlign: 'center' }}>
      <Typography variant="body-lg-rg" color={color.White100}>
        {t(I18N_KEYS.FIGMA_PROMO_WELCOME.TUTORIAL_PREFIX)}
        <Link
          href={YOUTUBE_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={INLINE_LINK_SX}
          onClick={() => trackLinkClick('youtube')}
        >
          {t(I18N_KEYS.FIGMA_PROMO_WELCOME.TUTORIAL_YOUTUBE_LINK)}
        </Link>
        {showEvent ? (
          <>
            {t(I18N_KEYS.FIGMA_PROMO_WELCOME.TUTORIAL_MID)}
            <Link
              href={EVENT_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={INLINE_LINK_SX}
              onClick={() => trackLinkClick('live_event')}
            >
              {t(I18N_KEYS.FIGMA_PROMO_WELCOME.TUTORIAL_EVENT_LINK)}
            </Link>
            {t(I18N_KEYS.FIGMA_PROMO_WELCOME.TUTORIAL_SUFFIX)}
          </>
        ) : (
          '.'
        )}
      </Typography>

      <Link
        href={PROMO_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="body-std-rg"
        sx={{ color: color.White64_T, textDecoration: 'underline' }}
        onClick={() => trackLinkClick('promo_terms')}
      >
        {t(I18N_KEYS.FIGMA_PROMO_WELCOME.PROMO_TERMS)}
      </Link>
    </Stack>
  );
}
